var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"chart",style:({ 'height': _vm.height })},[(_vm.ready)?_c('v-chart',{ref:"chart",staticStyle:{"overflow":"initial"},attrs:{"option":_vm.opts,"update-options":{ notMerge: true },"init-options":{ renderer: 'svg' },"events":_vm.events}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }